import React from 'react';
import { Table, ArrowRight, Check, FileSpreadsheet } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const GoogleSheetsPage = () => {
  const { login } = useAuth();
  const features = ['Exportação automática', 'Sincronização em tempo real', 'Dados de leads', 'Relatórios personalizados'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Table className="h-4 w-4" />Google Sheets
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Integração com <span className="text-green-600">Google Sheets</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">Exporte leads e dados automaticamente para planilhas do Google.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-green-50 rounded-3xl p-8">
              <div className="bg-white rounded-2xl p-4 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <FileSpreadsheet className="h-8 w-8 text-green-600" />
                  <span className="font-semibold">Leads ChatAlfa</span>
                </div>
                <div className="border rounded-lg overflow-hidden">
                  <div className="grid grid-cols-3 bg-green-100 text-xs font-medium p-2">
                    <span>Nome</span><span>Email</span><span>Tel</span>
                  </div>
                  <div className="grid grid-cols-3 text-xs p-2 border-t">
                    <span>João</span><span>joao@...</span><span>11999...</span>
                  </div>
                  <div className="grid grid-cols-3 text-xs p-2 border-t">
                    <span>Maria</span><span>maria@...</span><span>11988...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos da Integração</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Organize seus dados</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default GoogleSheetsPage;
